export default {"src":"/_next/static/media/0x5ffce65a40f6d3de5332766fff6a28bf491c868c.9e5ecb59.svg","height":122,"width":122,"blurWidth":0,"blurHeight":0};